import { stringify } from '@angular/compiler/src/util';
import { PosNoEnterCreditRequestReasonModalComponent } from './../../shared/pos-no-enter-credit-request-reason-modal/pos-no-enter-credit-request-reason-modal.component';
import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalDialogType } from '../constants';
import { Customer } from 'src/app/models/customer';

@Injectable({
  providedIn: 'root',
})
export class PosNoEnterCreditRequestReasonModalService {
  private modalRef?: BsModalRef<PosNoEnterCreditRequestReasonModalComponent>;
  constructor(private modalService: BsModalService) {}

  async show(customer:Customer, preApproveCode:string): Promise<boolean> {
    this.modalRef = this.modalService.show(
      PosNoEnterCreditRequestReasonModalComponent,
      {
        initialState: {
          customer,
          preApproveCode,
        },
        ignoreBackdropClick:true
      },
    );

    this.modalRef.setClass(`modal-dialog ${ModalDialogType.PRIMARY}`);

    return this.modalRef.content!.isAValidReasonSelected.toPromise();
  }
}
